import { SearchOptionsRequest } from './SearchOptionsRequest.model';

export class HoldingStorageObjectSearchOptionsRequest extends SearchOptionsRequest {
  holdingId: number;
  fromDate: Date;
  toDate: Date;
  storageObjectParentId = null;
  foldersOnly = false;
  // not contained to parent folder
  searchGlobally = false;
}
